"use client"
import React, { useState } from 'react'
import { toast } from 'react-toastify'

interface Props {
    couponCode: string
    className?: string
}

export default function ClientCopyButton({ couponCode, className }: Props) {
    const [copied, setCopied] = useState(false);

    const handleCopyClick = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        const code = couponCode?.trim() || "";
        if (!code) return;

        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(code);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            } else {
                // Fallback copy
                const textArea = document.createElement("textarea");
                textArea.value = code;
                textArea.style.position = "fixed";
                textArea.style.top = "0";
                textArea.style.left = "0";
                const target = document.body || document.documentElement;
                if (target) {
                    target.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    const successful = document.execCommand('copy');
                    target.removeChild(textArea);

                    if (successful) {
                        setCopied(true);
                        setTimeout(() => setCopied(false), 2000);
                    } else {
                        toast.error("Failed to copy code.");
                    }
                }
            }
        } catch (err) {
            console.error("Copy failed: ", err);
            toast.error("Failed to copy code.");
        }
    };

    return (
        <button onClick={handleCopyClick} className={className} type="button">
            {copied ? "Copied!" : "Copy"}
        </button>
    )
}
